// extracted by mini-css-extract-plugin
export default {"root":"List_root__RF5ra","movein":"List_movein__K0cXc"};